export { CommentsListComponent } from './lib/components/comments-list/comments-list.component';
export { CommentsModule } from './lib/comments.module';
